import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import Form1Form, { emptyForm1 } from "../components/forms/Form1Form";
import { demoIntake } from "../demo/demoData";
import { Button } from "../components/ui/button";

export default function NewClientPage() {
  const [data, setData] = useState(emptyForm1);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    if (!data.full_name.trim()) {
      toast.error("Client full name is required");
      return;
    }
    setBusy(true);
    try {
      const { data: client } = await api.post("/clients", { intake: data });
      toast.success(`Client created — ${client.forms?.intake?.full_name || "record ready"}`);
      navigate(`/clients/${client.id}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl" data-testid="new-client-page">
      <button onClick={() => navigate("/")} className="mb-4 inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-900" data-testid="back-to-dashboard">
        <ArrowLeft size={14} /> Back to clients
      </button>
      <div className="mb-8">
        <p className="text-xs font-medium uppercase tracking-wider text-primary">Form 1 — Client Master Record</p>
        <h1 className="mt-1 font-heading text-4xl font-semibold tracking-tight text-stone-900">Client Identifying Information</h1>
        <p className="mt-2 text-sm text-stone-500">
          The master record for this client. All forms, paperwork, and the generated care plan link to it.
        </p>
      </div>
      <Form1Form data={data} onChange={setData} />
      <div className="mt-8 flex justify-end gap-3">
        <Button variant="outline" onClick={() => { setData(JSON.parse(JSON.stringify(demoIntake))); toast.info("Demo intake data loaded"); }}
          className="border-stone-300 text-stone-700 hover:bg-accent" data-testid="intake-demo-button">
          Load Demo Data
        </Button>
        <Button variant="outline" onClick={() => navigate("/")} className="border-stone-300 text-stone-700 hover:bg-stone-100" data-testid="intake-cancel-button">Cancel</Button>
        <Button onClick={submit} disabled={busy} className="bg-primary text-primary-foreground hover:bg-stone-900" data-testid="intake-save-button">
          {busy ? "Creating..." : "Create Client"}
        </Button>
      </div>
    </div>
  );
}
